/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：2489
 */

module.exports = function (e) {
  return this.__data__.has(e)
}
